import { createApp as createClientApp, createSSRApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { createAppRouter } from './router'

// `hydrate` reuses prerendered markup instead of rendering the page from scratch.
export function createApp({ history, hydrate }) {
  const app = hydrate ? createSSRApp(App) : createClientApp(App)
  const router = createAppRouter(history)
  app.use(createPinia()).use(router)
  return { app, router }
}
